import { Autocomplete, Box, Chip, TextField } from "@mui/material";
import { Controller } from "react-hook-form";
import { personLabel } from "../../server/supabase-person-service";

import type { Permissions, PersonDetails } from "../../server/supabase-person-service";
import type { PermissionsFormType } from "../../types";
import type { FC } from "react";
import type { Control } from "react-hook-form";

export const EmployeeSelect: FC<{
  control: Control<PermissionsFormType>;
  employees: PersonDetails[];
  existing?: Permissions;
}> = ({ control, employees, existing }) => (
  <Controller
    name="person_ids"
    control={control}
    render={({ field, fieldState: { error } }) => (
      <Autocomplete
        multiple
        disabled={Boolean(existing)}
        id="employee-select"
        value={employees.filter((s) => field.value?.includes(s.id))}
        options={employees}
        renderOption={(renderProps, option) => (
          <Box component="li" {...renderProps} key={option.id}>
            {personLabel(option)}
          </Box>
        )}
        renderValue={(tagValue, getTagProps) =>
          tagValue.map((option, index) => (
            <Chip {...getTagProps({ index })} key={option.id} label={personLabel(option)} />
          ))
        }
        renderInput={(params) => (
          <TextField
            label="Select Employee(s)"
            variant="standard"
            {...params}
            helperText={error?.message}
            error={Boolean(error)}
            slotProps={{
              ...params.slotProps,
              input: { ...params.slotProps.input, "data-testid": "employee-select" },
            }}
          />
        )}
        getOptionLabel={(option) => personLabel(option)}
        onChange={(_, v) => {
          field.onChange(v.map((x) => x.id));
        }}
      />
    )}
  />
);
